module.exports = __webpack_public_path__ + "static/media/landingPageVideo1.f9f6ff3e.png";